import { Type } from "class-transformer";
import { CalendarOutlineEvent } from "./CalendarOutlineEvent";
import { Arrays } from "src/modules/utils/shared/arrays";
import { CalendarEventTemplate } from "./CalendarEventTemplate";
import { CustomInitializer } from "src/modules/sm-base/shared/custom-initializer.interface";

export class CalendarOutlineTemplate implements CustomInitializer {
    static combine(templates: CalendarOutlineTemplate[], useFromOutlineTemplateIds: number[]): CalendarOutlineTemplate {
        let combined = new CalendarOutlineTemplate();
        for (let t of templates) {
            for (let e of t.events) {
                if (e.fromOutlineTemplateId == null) {
                    e.fromOutlineTemplateId = t.id;
                }
            }
        }

        combined.structurePaths = Arrays.getUnique(Arrays.explode(templates, t => t.structurePaths));
        combined.events = Arrays.explode(templates, t => t.events);
        if (useFromOutlineTemplateIds != null) {
            combined.events = combined.events.filter(e => useFromOutlineTemplateIds.includes(e.fromOutlineTemplateId));
        }

        return combined;
    }

    //netgen start
    title: string;
    description: string;
    structurePaths: string[];
    @Type(() => CalendarOutlineEvent)
    events: CalendarOutlineEvent[];
    id = 0;
    //netgen end

    constructor() {
        this.customInitializer();
    }

    customInitializer(): void {
        this.structurePaths = Arrays.ensure(this.structurePaths);
        this.events = Arrays.ensure(this.events);
    }

    getStringRepresentation(): string {
        return this.title;
    }

    initForAddProject(eventTemplates: CalendarEventTemplate[]): void {
        for (let e of this.events) {
            e.copyFromTemplate(eventTemplates.find(t2 => t2.id == e.templateId));
        }
    }
}
